
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Testimonials</h1>
                </div>
            </div>
        </div>			
    </div>	
</section>  

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="main-timeline">
                    <div class="timeline mb-5" >
                        <div class="timeline-content p-3" >
                            <div class="text-center"><img src="assets/images/testi/mehul_siddhapara.webp" alt="Mehul Siddhapara" title="Mehul Siddhapara"></div>                            
                            <p>As for me the GHRCCST has been that experience which is simply amazing. The entire journey of 3 years had made me an all rounder. So, I have been the 2nd topper of the college and the runner up in the Dance competition. The institute has given me that platform which aided in my complete development. Amidst the plethora of amenities associated with the institute, the Toastermaster Club has been my greatest strength, guiding me and giving me that perfect dais to grow. I owe my present profile to the institutes’ attributes.</p>
                            <div class="inner-title text-right"  >
                                <h5>- MEHUL SIDDHAPARA</h5>
                                <h6>YEAR OF PASSING: 2016(BBA)</h6>
                            </div>
                        </div>
                    </div>
                    <div class="timeline mb-5" >
                        <div class="timeline-content p-3" >
                            <div class="text-center"><img src="assets/images/testi/amardeep.webp" alt="Amardeep Kaur Bhogal | Ghrcacsn" title="Amardeep Kaur Bhogal | Ghrcacsn"></div>                            
                            <p>It is a matter of immense pleasure mingled with pride to have been a part of the Graduation program of the GHRCCST College. The most promising aspect of the institute is the cordial relationship between the students and faculties. Undoubtedly, is has made me a ‘Better person’. The two years spent in here have been nothing short of splendid. They have been the catalyst to my growth both professionally and personally. The success which is reciprocated in my job profile presently is a huge payback from the Graduation program at the Raisoni.</p>
                            <div class="inner-title text-right"  >
                                <h5>- AMARDEEP KAUR BHOGAL</h5>
                                <h6>ASSISTANT TAX MANAGER AT DELOITTE TAX LLP</h6>
                            </div>
                        </div>
                    </div>
                    <div class="timeline mb-5" >
                        <div class="timeline-content p-3" >
                            <div class="text-center"><img src="assets/images/testi/sneha_lonkar.webp" alt="Sneha Lonkar | Ghrcacsn" title="Sneha Lonkar | Ghrcacsn"></div>                            
                            <p>A place which made me a better version of myself”- This is how I have always and will continue to describe the haven of knowledge, academics and information, the GHRCCST. It gave me that perfect platform which amalgamated academics well balanced with co-curricular activities. It made me grow. It made me, explore myself. And, it made me come out of the comfort zone. The events including RPL, Indradhanu, Toastmasters, Charter Chariot, Adventure camps and Excursion has aided me in carving a niche in my personality. It is aptly said, -“Once, you are a part of it, and then it becomes a part of you.”- Forever!</p>
                            <div class="inner-title text-right"  >
                                <h5>- SNEHA LONKAR</h5>
                                <h6>YEAR OF PASSING: 2015</h6>
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
        </div>
    </div>
</section>

